// extracted by mini-css-extract-plugin
export var hidden = "_tt-0";